import { createFeature, createReducer } from '@ngrx/store';

import { blueSageTerminalPushReducers } from './bluesage-terminal-push.reducer';
import { blueSageTerminalPushInitialState } from './bluesage-terminal-push.state';

export const blueSageTerminalPushFeature = createFeature({
    name: 'blueSageTerminalPush',
    reducer: createReducer(blueSageTerminalPushInitialState, ...blueSageTerminalPushReducers),
});
